export default "assets/images/transportation-16543fab.svg";